export enum FeedbackRowType {
  Select = 'Select',
  Star = 'Star',
  TextArea = 'TextArea',
  Toggle = 'Toggle',
}

export interface IBaseRowStructure<TType extends FeedbackRowType> {
  // we need to define each row with ID, will be used for BI data
  id: string;
  type: TType;
  label: string;
  placeholder?: string;
  // NOTE: we decided there are no any validation which means there are no any required field
  // required: boolean;
}

export interface ITextAreaRowStructure
  extends IBaseRowStructure<FeedbackRowType.TextArea> {}

export interface ISelectRowStructure
  extends IBaseRowStructure<FeedbackRowType.Select> {
  options: {
    id: string;
    displayName: string;
  }[];
}

export interface IToggleRowStructure
  extends IBaseRowStructure<FeedbackRowType.Toggle> {
  buttons: {
    id: string;
    displayName: string;
  }[];
}

export interface IStarRowStructure
  extends IBaseRowStructure<FeedbackRowType.Star> {
  tooltips?: [string, string, string, string, string];
}

export type IStructure<TType extends FeedbackRowType> = {
  [FeedbackRowType.TextArea]: ITextAreaRowStructure;
  [FeedbackRowType.Select]: ISelectRowStructure;
  [FeedbackRowType.Toggle]: IToggleRowStructure;
  [FeedbackRowType.Star]: IStarRowStructure;
}[TType];

export interface IFeedbackFormStructure {
  id: string;
  title: string;
  rows: (
    | ITextAreaRowStructure
    | ISelectRowStructure
    | IToggleRowStructure
    | IStarRowStructure
  )[];
}
